import { isMobile, onDeviceChange } from '@/utils/responsive';

/**
 * 设备检测混入
 * 提供响应式的设备类型检测
 */
export const responsiveMixin = {
  data() {
    return {
      isMobile: false,
      removeDeviceListener: null
    };
  },

  mounted() {
    // 初始化设备检测
    this.isMobile = isMobile();
    
    // 监听屏幕大小变化
    this.removeDeviceListener = onDeviceChange((mobile) => {
      this.isMobile = mobile;
    });
  },

  beforeDestroy() {
    // 移除监听器
    if (this.removeDeviceListener) {
      this.removeDeviceListener();
    }
  },

  computed: {
    // 计算属性：当前设备类型
    deviceType() {
      return this.isMobile ? 'mobile' : 'pc';
    },

    // 计算属性：是否为PC端
    isPC() {
      return !this.isMobile;
    }
  }
};

export default responsiveMixin; 